import { INotificationsState, actionTypes } from 'src/ducks/notifications.duck';
import { IStatus } from 'src/libraries/thunk.library';

export const getNotificationsStatus = (
  state: INotificationsState,
  action: keyof typeof actionTypes
): IStatus =>
  state.status[action] ?? {
    fetching: false,
    error: null,
  };
